import type { Template } from "@/types";

export const PO_05_H2_V3: Template[] = [
{
    id: "po-05-h2v3-01",
    name: "PO 01 - H2V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h2_v3_01.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 75, y: 169, width: 226, height: 348, rotation: 0, imageRotation: 0 },
            { id: "2", x: 309, y: 169, width: 226, height: 348, rotation: 0, imageRotation: 0 },
            { id: "3", x: 75, y: 525, width: 226, height: 157, rotation: 0, imageRotation: 0 },
            { id: "4", x: 309, y: 525, width: 226, height: 157, rotation: 0, imageRotation: 0 },
            { id: "5", x: 685, y: 75, width: 454, height: 702, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h2v3-02",
    name: "PO 02 - H2V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h2_v3_02.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 30, y: 0, width: 550, height: 851, rotation: 0, imageRotation: 0 },
            { id: "2", x: 674, y: 151, width: 235, height: 372, rotation: 0, imageRotation: 0 },
            { id: "3", x: 917, y: 151, width: 235, height: 372, rotation: 0, imageRotation: 0 },
            { id: "4", x: 674, y: 531, width: 235, height: 168, rotation: 0, imageRotation: 0 },
            { id: "5", x: 917, y: 531, width: 235, height: 168, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h2v3-03",
    name: "PO 03 - H2V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h2_v3_03.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 29, y: 0, width: 539, height: 851, rotation: 0, imageRotation: 0 },
        { id: "2", x: 675, y: 157, width: 230, height: 164, rotation: 0, imageRotation: 0 },    
        { id: "3", x: 675, y: 329, width: 230, height: 364, rotation: 0, imageRotation: 0 },
        { id: "4", x: 913, y: 157, width: 231, height: 364, rotation: 0, imageRotation: 0 },
        { id: "5", x: 913, y: 529, width: 231, height: 164, rotation: 0, imageRotation: 0 },
    ],
},

{
    id: "po-05-h2v3-04",
    name: "PO 04 - H2V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h2_v3_04.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 82, y: 82, width: 444, height: 687, rotation: 0, imageRotation: 0 },
        { id: "2", x: 670, y: 167, width: 474, height: 330, rotation: 0, imageRotation: 0 },
        { id: "3", x: 790, y: 505, width: 234, height: 180, rotation: 0, imageRotation: 0 },
        { id: "4", x: 670, y: 505, width: 112, height: 180, rotation: 0, imageRotation: 0 },
        { id: "5", x: 1032, y: 505, width: 111, height: 180, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h2v3-05",
    name: "PO 05 - H2V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h2_v3_05.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 80, y: 167, width: 431, height: 305, rotation: 0, imageRotation: 0 },
        { id: "2", x: 80, y: 480, width: 284, height: 205, rotation: 0, imageRotation: 0 },
        { id: "3", x: 372, y: 480, width: 139, height: 205, rotation: 0, imageRotation: 0 },
        { id: "4", x: 657, y: 226, width: 253, height: 397, rotation: 0, imageRotation: 0 },
        { id: "5", x: 918, y: 226, width: 252, height: 397, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h2v3-06",
    name: "PO 06 - H2V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h2_v3_06.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 55, y: 236, width: 245, height: 378, rotation: 0, imageRotation: 0 },
        { id: "2", x: 308, y: 236, width: 245, height: 378, rotation: 0, imageRotation: 0 },
        { id: "3", x: 919, y: 236, width: 254, height: 379, rotation: 0, imageRotation: 0 },
        { id: "4", x: 656, y: 236, width: 255, height: 186, rotation: 0, imageRotation: 0 },
        { id: "5", x: 656, y: 430, width: 255, height: 185, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h2v3-07",
    name: "PO 07 - H2V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h2_v3_07.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 34, y: 201, width: 281, height: 450, rotation: 0, imageRotation: 0 },
            { id: "2", x: 323, y: 201, width: 281, height: 450, rotation: 0, imageRotation: 0 },
            { id: "3", x: 613, y: 201, width: 281, height: 450, rotation: 0, imageRotation: 0 },
            { id: "4", x: 902, y: 201, width: 281, height: 221, rotation: 0, imageRotation: 0 },
            { id: "5", x: 902, y: 431, width: 281, height: 220, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h2v3-08",
    name: "PO 08 - H2V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h2_v3_08.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 0, y: 158, width: 760, height: 535, rotation: 0, imageRotation: 0 },
            { id: "2", x: 768, y: 158, width: 450, height: 311, rotation: 0, imageRotation: 0 },
            { id: "3", x: 768, y: 477, width: 145, height: 216, rotation: 0, imageRotation: 0 },
            { id: "4", x: 921, y: 477, width: 144, height: 216, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1074, y: 477, width: 144, height: 216, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h2v3-09",
    name: "PO 09 - H2V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h2_v3_09.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 36, y: 205, width: 281, height: 441, rotation: 0, imageRotation: 0 },      
        { id: "2", x: 325, y: 205, width: 280, height: 217, rotation: 0, imageRotation: 0 },
        { id: "3", x: 325, y: 430, width: 280, height: 216, rotation: 0, imageRotation: 0 },
        { id: "4", x: 613, y: 205, width: 280, height: 441, rotation: 0, imageRotation: 0 },
        { id: "5", x: 901, y: 205, width: 280, height: 441, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h2v3-10",
    name: "PO 10 - H2V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h2_v3_10.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 0, y: 191, width: 299, height: 469, rotation: 0, imageRotation: 0 },
        { id: "2", x: 307, y: 191, width: 298, height: 469, rotation: 0, imageRotation: 0 },    
        { id: "3", x: 613, y: 191, width: 298, height: 231, rotation: 0, imageRotation: 0 },
        { id: "4", x: 613, y: 430, width: 298, height: 230, rotation: 0, imageRotation: 0 },
        { id: "5", x: 919, y: 191, width: 298, height: 469, rotation: 0, imageRotation: 0 }
    ],
}
];